import Avatar from "@material-ui/core/Avatar";
import React from "react";
import {dateFormat, MIcon, IntlMessageValue} from "../../../../../@WUM/core/Elements";
import {responsibilityApiTYpe} from "../../../../ticketsystem/API/request/responsibility.Api,interface";
import {TicketActivityRecord} from "../../../API/request/ticket.interface";


interface WorkLogCommentItemProps {
    comment: TicketActivityRecord;
    user?: responsibilityApiTYpe;
    isOwnComment: boolean;
    Store: any
}

export const WorkLogCommentItem = (props: WorkLogCommentItemProps): JSX.Element => {

    const {comment, user, isOwnComment, Store} = props;

    const hasContent: boolean = comment.content !== null && comment.content.trim() !== "";

    console.log(isOwnComment);

    return (
        <div className={`border rounded p-3 mb-2 ${isOwnComment ? "bg-light border-primary" : "bg-white"}`}>
            <div className="d-flex align-items-start gap-2">
                <Avatar
                    alt={user?.username ?? ""}
                    title={user?.username ?? ""}
                    src={user?.media ?? ""}
                    className={"cardAvatarMini"}
                />

                <div className="w-100">
                    <div className="d-flex justify-content-between align-items-start gap-2">
                        <div>
                            <div className="fw-bold">
                                {user?.username ?? IntlMessageValue("","ticket.unknown.user",Store)}

                                {isOwnComment && (
                                    <span className="badge bg-primary ms-2">
                                        {IntlMessageValue("","ticket.own.comment",Store)}
                                    </span>
                                )}
                            </div>

                            <div className="text-muted small">
                                {dateFormat(
                                    comment.createdAt,
                                    localStorage.getItem('locale'),
                                    'us',
                                    true,
                                    "",
                                    Store
                                )}
                            </div>
                        </div>

                        <span
                            className={`badge d-inline-flex align-items-center gap-1 ${comment.public ? "bg-success" : "bg-secondary"}`}
                            title={comment.public
                                ? IntlMessageValue("","ticket.public.comment",Store)
                                : IntlMessageValue("","ticket.internal.comment",Store)
                            }
                        >
                            <MIcon
                                className={"d-flex m-0 fs-6"}
                                children={comment.public ? "public" : "lock"}
                            />
                            {comment.public
                                ? IntlMessageValue("","ticket.public.badge",Store)
                                : IntlMessageValue("","ticket.internal",Store)
                            }
                        </span>
                    </div>

                    <div className="mt-2">
                        {hasContent ? (
                            comment.content
                        ) : (
                            <span className="text-muted fst-italic">
                                {IntlMessageValue("","ticket.no.content",Store)}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};